import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Translation resources
const resources = {
  en: {
    translation: {
      // Navigation
      home: 'Home',
      services: 'Services',
      booking: 'Book Now',
      about: 'About',
      contact: 'Contact',
      login: 'Login',
      signup: 'Sign Up',
      dashboard: 'Dashboard',
      
      // Common actions
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      edit: 'Edit',
      create: 'Create',
      update: 'Update',
      submit: 'Submit',
      back: 'Back',
      next: 'Next',
      continue: 'Continue',
      confirm: 'Confirm',
      close: 'Close',
      loading: 'Loading...',
      
      // Booking flow
      selectService: 'Select Service',
      chooseDateTime: 'Choose Date & Time',
      yourInformation: 'Your Information',
      confirmation: 'Confirmation',
      bookingConfirmed: 'Booking Confirmed!',
      
      // Service details
      duration: 'Duration',
      price: 'Price',
      minutes: 'minutes',
      selectThisService: 'Select This Service',
      serviceDescription: 'Service Description',
      
      // Date and time
      selectDate: 'Select Date',
      selectTime: 'Select Time',
      availableSlots: 'Available Times',
      noSlotsAvailable: 'No time slots available for this date',
      
      // Customer information
      fullName: 'Full Name',
      emailAddress: 'Email Address',
      phoneNumber: 'Phone Number',
      notes: 'Notes or Special Requests',
      optional: 'Optional',
      required: 'Required',
      
      // Booking confirmation
      appointmentDetails: 'Appointment Details',
      customerDetails: 'Customer Details',
      serviceDetails: 'Service Details',
      dateTime: 'Date & Time',
      location: 'Location',
      confirmationNumber: 'Confirmation Number',
      
      // Messages
      thankYouBooking: 'Thank you for your booking! We\'ll send you a confirmation email shortly.',
      cancellationPolicy: 'Cancellations must be made at least 24 hours in advance.',
      emailConfirmation: 'A confirmation email has been sent to your email address.',
      
      // Errors
      errorOccurred: 'An error occurred',
      pleaseCompleteRequired: 'Please complete all required fields',
      invalidEmail: 'Please enter a valid email address',
      invalidPhone: 'Please enter a valid phone number',
      bookingFailed: 'Booking failed. Please try again.',
      
      // Business information
      businessHours: 'Business Hours',
      address: 'Address',
      phone: 'Phone',
      email: 'Email',
      website: 'Website',
      followUs: 'Follow Us',
      
      // Days of week
      monday: 'Monday',
      tuesday: 'Tuesday',
      wednesday: 'Wednesday',
      thursday: 'Thursday',
      friday: 'Friday',
      saturday: 'Saturday',
      sunday: 'Sunday',
      
      // Time periods
      morning: 'Morning',
      afternoon: 'Afternoon',
      evening: 'Evening',
      
      // Timezone
      yourTimezone: 'Your Timezone',
      businessTimezone: 'Business Timezone',
      timezoneNote: 'Times shown in your local timezone',
      
      // Categories
      massage: 'Massage',
      skincare: 'Skincare',
      nailCare: 'Nail Care',
      haircare: 'Hair Care',
      wellness: 'Wellness',
      beauty: 'Beauty'
    }
  },
  
  es: {
    translation: {
      // Navigation
      home: 'Inicio',
      services: 'Servicios',
      booking: 'Reservar',
      about: 'Acerca de',
      contact: 'Contacto',
      login: 'Iniciar Sesión',
      signup: 'Registrarse',
      dashboard: 'Panel',
      
      // Common actions
      save: 'Guardar',
      cancel: 'Cancelar',
      delete: 'Eliminar',
      edit: 'Editar',
      create: 'Crear',
      update: 'Actualizar',
      submit: 'Enviar',
      back: 'Atrás',
      next: 'Siguiente',
      continue: 'Continuar',
      confirm: 'Confirmar',
      close: 'Cerrar',
      loading: 'Cargando...',
      
      // Booking flow
      selectService: 'Seleccionar Servicio',
      chooseDateTime: 'Elegir Fecha y Hora',
      yourInformation: 'Tu Información',
      confirmation: 'Confirmación',
      bookingConfirmed: '¡Reserva Confirmada!',
      
      // Service details
      duration: 'Duración',
      price: 'Precio',
      minutes: 'minutos',
      selectThisService: 'Seleccionar Este Servicio',
      serviceDescription: 'Descripción del Servicio',
      
      // Date and time
      selectDate: 'Seleccionar Fecha',
      selectTime: 'Seleccionar Hora',
      availableSlots: 'Horarios Disponibles',
      noSlotsAvailable: 'No hay horarios disponibles para esta fecha',
      
      // Customer information
      fullName: 'Nombre Completo',
      emailAddress: 'Dirección de Email',
      phoneNumber: 'Número de Teléfono',
      notes: 'Notas o Solicitudes Especiales',
      optional: 'Opcional',
      required: 'Requerido',
      
      // Booking confirmation
      appointmentDetails: 'Detalles de la Cita',
      customerDetails: 'Detalles del Cliente',
      serviceDetails: 'Detalles del Servicio',
      dateTime: 'Fecha y Hora',
      location: 'Ubicación',
      confirmationNumber: 'Número de Confirmación',
      
      // Messages
      thankYouBooking: '¡Gracias por tu reserva! Te enviaremos un email de confirmación pronto.',
      cancellationPolicy: 'Las cancelaciones deben hacerse con al menos 24 horas de anticipación.',
      emailConfirmation: 'Se ha enviado un email de confirmación a tu dirección de correo.',
      
      // Errors
      errorOccurred: 'Ocurrió un error',
      pleaseCompleteRequired: 'Por favor completa todos los campos requeridos',
      invalidEmail: 'Por favor ingresa un email válido',
      invalidPhone: 'Por favor ingresa un número de teléfono válido',
      bookingFailed: 'La reserva falló. Por favor intenta nuevamente.',
      
      // Business information
      businessHours: 'Horario de Atención',
      address: 'Dirección',
      phone: 'Teléfono',
      email: 'Email',
      website: 'Sitio Web',
      followUs: 'Síguenos',
      
      // Days of week
      monday: 'Lunes',
      tuesday: 'Martes',
      wednesday: 'Miércoles',
      thursday: 'Jueves',
      friday: 'Viernes',
      saturday: 'Sábado',
      sunday: 'Domingo',
      
      // Time periods
      morning: 'Mañana',
      afternoon: 'Tarde',
      evening: 'Noche',
      
      // Timezone
      yourTimezone: 'Tu Zona Horaria',
      businessTimezone: 'Zona Horaria del Negocio',
      timezoneNote: 'Horarios mostrados en tu zona horaria local',
      
      // Categories
      massage: 'Masajes',
      skincare: 'Cuidado de la Piel',
      nailCare: 'Cuidado de Uñas',
      haircare: 'Cuidado del Cabello',
      wellness: 'Bienestar',
      beauty: 'Belleza'
    }
  },
  
  fr: {
    translation: {
      // Navigation
      home: 'Accueil',
      services: 'Services',
      booking: 'Réserver',
      about: 'À Propos',
      contact: 'Contact',
      login: 'Connexion',
      signup: 'S\'inscrire',
      dashboard: 'Tableau de Bord',
      
      // Common actions
      save: 'Sauvegarder',
      cancel: 'Annuler',
      delete: 'Supprimer',
      edit: 'Modifier',
      create: 'Créer',
      update: 'Mettre à Jour',
      submit: 'Soumettre',
      back: 'Retour',
      next: 'Suivant',
      continue: 'Continuer',
      confirm: 'Confirmer',
      close: 'Fermer',
      loading: 'Chargement...',
      
      // Booking flow
      selectService: 'Sélectionner un Service',
      chooseDateTime: 'Choisir Date et Heure',
      yourInformation: 'Vos Informations',
      confirmation: 'Confirmation',
      bookingConfirmed: 'Réservation Confirmée!',
      
      // Service details
      duration: 'Durée',
      price: 'Prix',
      minutes: 'minutes',
      selectThisService: 'Sélectionner ce Service',
      serviceDescription: 'Description du Service',
      
      // Date and time
      selectDate: 'Sélectionner une Date',
      selectTime: 'Sélectionner une Heure',
      availableSlots: 'Créneaux Disponibles',
      noSlotsAvailable: 'Aucun créneau disponible pour cette date',
      
      // Customer information
      fullName: 'Nom Complet',
      emailAddress: 'Adresse Email',
      phoneNumber: 'Numéro de Téléphone',
      notes: 'Notes ou Demandes Spéciales',
      optional: 'Optionnel',
      required: 'Requis',
      
      // Booking confirmation
      appointmentDetails: 'Détails du Rendez-vous',
      customerDetails: 'Détails du Client',
      serviceDetails: 'Détails du Service',
      dateTime: 'Date et Heure',
      location: 'Emplacement',
      confirmationNumber: 'Numéro de Confirmation',
      
      // Messages
      thankYouBooking: 'Merci pour votre réservation! Nous vous enverrons un email de confirmation sous peu.',
      cancellationPolicy: 'Les annulations doivent être faites au moins 24 heures à l\'avance.',
      emailConfirmation: 'Un email de confirmation a été envoyé à votre adresse email.',
      
      // Errors
      errorOccurred: 'Une erreur s\'est produite',
      pleaseCompleteRequired: 'Veuillez compléter tous les champs requis',
      invalidEmail: 'Veuillez entrer une adresse email valide',
      invalidPhone: 'Veuillez entrer un numéro de téléphone valide',
      bookingFailed: 'La réservation a échoué. Veuillez réessayer.',
      
      // Business information
      businessHours: 'Heures d\'Ouverture',
      address: 'Adresse',
      phone: 'Téléphone',
      email: 'Email',
      website: 'Site Web',
      followUs: 'Suivez-nous',
      
      // Days of week
      monday: 'Lundi',
      tuesday: 'Mardi',
      wednesday: 'Mercredi',
      thursday: 'Jeudi',
      friday: 'Vendredi',
      saturday: 'Samedi',
      sunday: 'Dimanche',
      
      // Time periods
      morning: 'Matin',
      afternoon: 'Après-midi',
      evening: 'Soir',
      
      // Timezone
      yourTimezone: 'Votre Fuseau Horaire',
      businessTimezone: 'Fuseau Horaire de l\'Entreprise',
      timezoneNote: 'Heures affichées dans votre fuseau horaire local',
      
      // Categories
      massage: 'Massage',
      skincare: 'Soins de la Peau',
      nailCare: 'Soins des Ongles',
      haircare: 'Soins Capillaires',
      wellness: 'Bien-être',
      beauty: 'Beauté'
    }
  },
  
  de: {
    translation: {
      // Navigation
      home: 'Startseite',
      services: 'Dienstleistungen',
      booking: 'Buchen',
      about: 'Über Uns',
      contact: 'Kontakt',
      login: 'Anmelden',
      signup: 'Registrieren',
      dashboard: 'Dashboard',
      
      // Common actions
      save: 'Speichern',
      cancel: 'Abbrechen',
      delete: 'Löschen',
      edit: 'Bearbeiten',
      create: 'Erstellen',
      update: 'Aktualisieren',
      submit: 'Senden',
      back: 'Zurück',
      next: 'Weiter',
      continue: 'Fortfahren',
      confirm: 'Bestätigen',
      close: 'Schließen',
      loading: 'Laden...',
      
      // Booking flow
      selectService: 'Service Auswählen',
      chooseDateTime: 'Datum und Zeit Wählen',
      yourInformation: 'Ihre Informationen',
      confirmation: 'Bestätigung',
      bookingConfirmed: 'Buchung Bestätigt!',
      
      // Service details
      duration: 'Dauer',
      price: 'Preis',
      minutes: 'Minuten',
      selectThisService: 'Diesen Service Auswählen',
      serviceDescription: 'Service Beschreibung',
      
      // Date and time
      selectDate: 'Datum Auswählen',
      selectTime: 'Zeit Auswählen',
      availableSlots: 'Verfügbare Zeiten',
      noSlotsAvailable: 'Keine Zeitslots für dieses Datum verfügbar',
      
      // Customer information
      fullName: 'Vollständiger Name',
      emailAddress: 'E-Mail-Adresse',
      phoneNumber: 'Telefonnummer',
      notes: 'Notizen oder Spezielle Wünsche',
      optional: 'Optional',
      required: 'Erforderlich',
      
      // Booking confirmation
      appointmentDetails: 'Termin Details',
      customerDetails: 'Kunden Details',
      serviceDetails: 'Service Details',
      dateTime: 'Datum und Zeit',
      location: 'Standort',
      confirmationNumber: 'Bestätigungsnummer',
      
      // Messages
      thankYouBooking: 'Vielen Dank für Ihre Buchung! Wir senden Ihnen in Kürze eine Bestätigungs-E-Mail.',
      cancellationPolicy: 'Stornierungen müssen mindestens 24 Stunden im Voraus erfolgen.',
      emailConfirmation: 'Eine Bestätigungs-E-Mail wurde an Ihre E-Mail-Adresse gesendet.',
      
      // Errors
      errorOccurred: 'Ein Fehler ist aufgetreten',
      pleaseCompleteRequired: 'Bitte füllen Sie alle erforderlichen Felder aus',
      invalidEmail: 'Bitte geben Sie eine gültige E-Mail-Adresse ein',
      invalidPhone: 'Bitte geben Sie eine gültige Telefonnummer ein',
      bookingFailed: 'Buchung fehlgeschlagen. Bitte versuchen Sie es erneut.',
      
      // Business information
      businessHours: 'Öffnungszeiten',
      address: 'Adresse',
      phone: 'Telefon',
      email: 'E-Mail',
      website: 'Webseite',
      followUs: 'Folgen Sie Uns',
      
      // Days of week
      monday: 'Montag',
      tuesday: 'Dienstag',
      wednesday: 'Mittwoch',
      thursday: 'Donnerstag',
      friday: 'Freitag',
      saturday: 'Samstag',
      sunday: 'Sonntag',
      
      // Time periods
      morning: 'Morgen',
      afternoon: 'Nachmittag',
      evening: 'Abend',
      
      // Timezone
      yourTimezone: 'Ihre Zeitzone',
      businessTimezone: 'Geschäfts-Zeitzone',
      timezoneNote: 'Zeiten in Ihrer lokalen Zeitzone angezeigt',
      
      // Categories
      massage: 'Massage',
      skincare: 'Hautpflege',
      nailCare: 'Nagelpflege',
      haircare: 'Haarpflege',
      wellness: 'Wellness',
      beauty: 'Schönheit'
    }
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    debug: process.env.NODE_ENV === 'development',
    
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    
    detection: {
      order: ['querystring', 'cookie', 'localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage', 'cookie'],
      lookupQuerystring: 'lng',
      lookupCookie: 'i18next',
      lookupLocalStorage: 'i18nextLng',
      checkWhitelist: true
    }
  });

export default i18n;